import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isLogin } from "../utils/utils";
import Header from "./Header";
import Sidebar from "./Sidebar";

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <React.Fragment>
      <Header />
      <div className="container" style={{ paddingTop: 95 + "px" }}>
        <Route
          {...rest}
          render={(props) =>
            isLogin() ? (
              <Component {...rest} key={Math.random()} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
      </div>
    </React.Fragment>
  );
};

export default PrivateRoute;
